// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"195":"bd776268","230":"9d1c9f12"}[chunkId] + ".js";
};